module.exports = __webpack_public_path__ + "img/search_s.a9fb3363.svg";